import React, { useRef } from 'react'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { useOutsideClick } from '../../../hooks/useOutsideClick'
import { closeModalWithDelay } from '../../../redux/slices/modalSlice'
import Utils from '../../../core/Utils'
import { useNavigate } from 'react-router'
import { ModalType } from '../../../core/enums/Modals'
import { RootState } from '../../../redux/store'
import GamificationBlock from '../../GamificationBlock/GamificationBlock'
import { WIDGETS } from '../../../core/widgets'

interface InboxModalProps {
	position?: {
		top: number
		left: number
		width: number
		height: number
	}
}

const InboxModal = ({ position }: InboxModalProps) => {
	const isMobile = Utils.isMobile()
	const navigate = useNavigate()
	const dispatch = useAppDispatch()
	const {
		modalProps: { isVisible },
	} = useAppSelector((state: RootState) => state.modal)

	const modalRef = useRef<HTMLDivElement>(null)
	const handleClose = () => {
		dispatch(closeModalWithDelay())
	}

	useOutsideClick(modalRef, handleClose, ModalType.Inbox)

	const modalStyle = position
		? {
				top: position.top + position.height,
				left: position.left,
		  }
		: {}

	return (
		<div className={`inbox-container ${isVisible || isMobile ? 'animated' : ''}`} style={modalStyle} ref={modalRef}>
			{isMobile && (
				<div className="inbox-header">
					<div className="back-btn" onClick={() => navigate(-1)}></div>
					<div className="title">Inbox</div>
				</div>
			)}
			<GamificationBlock
				domId={WIDGETS.inbox.domId}
				url={WIDGETS.inbox.url}
				fit="content"
				className="gamification-block--inbox"
			/>
		</div>
	)
}

export default InboxModal
